import type {
    Account,
    AccountId,
    AccountInterest,
    AccountNumber,
    LoanDetails,
    LoanRepaymentPlan,
    DownpaymentRequest,
    LoanApplication,
    LoanStakeholder,
    LoanPayment,
} from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get, post, put } from './request';

const SERVICE_PATH = 'rest/resource/loans';

export async function getEkbLoans(): Promise<Account[]> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/ekb`);
}

export async function getLoanRepaymentPlan(accountId: AccountId): Promise<LoanRepaymentPlan> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/${accountId.value}/repayment-plan`);
}

export async function getLoanDetails(loanAccountId: AccountId): Promise<LoanDetails | undefined> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/${loanAccountId.value}/details`);
}

export async function getLoanInterests(loanAccountId: AccountId): Promise<AccountInterest | undefined> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/${loanAccountId.value}/interest`);
}

export async function updateLoanAccountDebitAccountNumber(
    loanAccountId: AccountId,
    newAccountNumber: AccountNumber,
): Promise<void> {
    return put(`${CONTEXT_PATH}/${SERVICE_PATH}/${loanAccountId.value}/details/debit-account`, newAccountNumber);
}

export async function updateLoanAccountPaymentDay(
    loanAccountId: AccountId,
    newPaymentDay: number,
    paymentDayNextMonth = false,
): Promise<void> {
    return put(
        `${CONTEXT_PATH}/${SERVICE_PATH}/${loanAccountId.value}/details/payment-day?paymentDayNextMonth=${paymentDayNextMonth}`,
        newPaymentDay,
    );
}

export async function createDownpayment(loanAccountId: AccountId, request: DownpaymentRequest) {
    return post<void>(`${CONTEXT_PATH}/${SERVICE_PATH}/${loanAccountId.value}/downpayment`, request);
}

export async function getAllLoanPayments(): Promise<LoanPayment[]> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/payments`);
}

export async function getLoanApplications(): Promise<LoanApplication[]> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/loan-applications`);
}

export async function getLoanStakeholders(loanAccountId: AccountId): Promise<LoanStakeholder[]> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/${loanAccountId.value}/stakeholders`);
}
